module.exports = __webpack_public_path__ + "media/svg/circle_mail-0cdab371.svg";